<template>
	<div id="one" 
		class="modal state_caution fade bs-example-modal-sm new-model" 
		:class="{'state_true': trueFlag,'state_false':falseFlag}"
		tabindex="-1" 
		role="dialog" 
		aria-labelledby="mySmallModalLabel" 
		aria-hidden="true">
	    <div class="modal-dialog modal-sm">
	        <div class="modal-content content_size">
	            <div class="modal-body body_modal_size text-center">
	                <div class="modal_icon"></div>
	                <div class="state_text_box">
	                    <span class="state_text"></span>
	                    <span class="state_text1" v-text="tipMsg"></span>
	                </div>
	                <span class="btn state_btn" @click="trueBtn" id="btnSub" data-dismiss="modal">确定</span>
	            </div>
	        </div>
	    </div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				
			}
		},
		props: [
			'tipMsg',
			'trueFlag',
			'falseFlag',
		],
		methods: {
			trueBtn(){
				this.$emit('trueBtn');
			},
		},
	}
</script>

<style>
	
/*--模态框--*/
.content_size {
	width: 300px;
	margin: auto;
}

.body_modal_size {
    font-size: 16px;
}

.new-model{
  	z-index:999999;
}

.state_caution .modal_icon {
    background: url("../assets/images/ico-caution.png") no-repeat center center;
    -webkit-background-size: 50px;
    background-size: 50px;
}

.state_true .modal_icon {
    background: url("../assets/images/ico-success.png") no-repeat center center;
    -webkit-background-size: 50px;
    background-size: 50px;
}

.state_false .modal_icon {
    background: url("../assets/images/ico-failure.png") no-repeat center center;
    -webkit-background-size: 50px;
    background-size: 50px;
}

.modal_icon {
    width: 100%;
    height: 55px;
    margin-top: 10px;
}

.state_text_box {
    color: #333;
    padding: 10px 0;
}

.state_sub_box {
    display: none;
    font-size: 12px;
    margin-bottom: 10px;
}

.state_caution .state_sub_box {
    display: block;
}

.state_failure .state_sub_box {
    display: block;
}

.state_btn {
    background: #CDD3D8;
	color: #2F2D2D;
}
</style>


// WEBPACK FOOTER //
// tip.vue?2b2482db